import { RegistrationState } from '../../store/registration/registration.interface';
import { RegistrationDtoIn } from '../../generated';
import { fromPatientToGenerated } from './patient.parser';
import { fromDoctorToGenerated } from './doctor.parser';
import { fromUploadToGenerated } from './upload.parser';
import { RequestType } from '../../model/enums/RequestType';
import { fromRequestTypeToGenerated } from './requestType.parser';
import { fromUrgencyToGenerated } from './urgency.parser';

export const fromRegistrationToGenerated = (data: RegistrationState, requestType: RequestType): RegistrationDtoIn => {
  const selectedDiagnoses = [...data.diagnoses];

  if (data.customDiagnosis.length) {
    selectedDiagnoses.push(data.customDiagnosis);
  }

  return {
    formType: fromRequestTypeToGenerated(requestType),
    goal: data.goal,
    clinic: data.clinic?.name ?? '',
    urgency: fromUrgencyToGenerated(data.urgency),
    diagnoses: selectedDiagnoses,
    description: data.description,
    patientInfo: fromPatientToGenerated(data.patient),
    doctorInfo: fromDoctorToGenerated(data.doctor),
    uploads: data.uploads.map(fromUploadToGenerated)
  };
};
